import newsletterSignup from '../modules/newsletter_signup';

let newslettersController = () => {
    const localNewsletterSignup = newsletterSignup('.js-newsletter-form');
    localNewsletterSignup.init();
};

export default newslettersController;
